exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-notification__root--3BwJk{-ms-flex-align:center;-webkit-box-align:center;align-items:center;background:#fff;border-bottom:1px solid #e6e6e6;display:-webkit-box;display:-ms-flexbox;display:flex;padding:20px}.besidaMob-notification__text--F3M4e{-ms-flex:1;-webkit-box-flex:1;flex:1;font-size:13px;min-width:1px}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-notification__root--3BwJk",
	"text": "besidaMob-notification__text--F3M4e"
};